module.exports = __webpack_public_path__ + "img/searchTipTitle.c502140c.png";